import { Preferences } from '@capacitor/preferences'

import { platform } from '@utils/capacitor-helper'

const LAST_LAUNCH_URL_KEY = 'lastLaunchUrl'

export async function getLastLaunchUrl(): Promise<string | null> {
    if (platform === 'web') return localStorage.getItem(LAST_LAUNCH_URL_KEY)

    const result = await Preferences.get({ key: LAST_LAUNCH_URL_KEY })
    return result.value
}

export async function setLastLaunchUrl(value: string): Promise<void> {
    if (platform === 'web') {
        localStorage.setItem(LAST_LAUNCH_URL_KEY, value)
        return
    }

    await Preferences.set({ key: LAST_LAUNCH_URL_KEY, value })
}

export async function clearLastLaunchUrl(): Promise<void> {
    if (platform === 'web') {
        localStorage.removeItem(LAST_LAUNCH_URL_KEY)
        return
    }

    await Preferences.remove({ key: LAST_LAUNCH_URL_KEY })
}
